// src/components/GuestRoute.jsx
import { Navigate } from 'react-router-dom';

export default function GuestRoute({ children }) {
  const token = localStorage.getItem('jwtToken') || sessionStorage.getItem('jwtToken');

  return token ? <Navigate to="/dashboard" replace /> : children;
}
